import { damagingNameConstants } from "_constants";
import { REHYDRATE } from "redux-persist/lib/constants";
import { produce } from "immer";

const initState = {
  damagingPartyRecords: [],
  claimRecords: [],
  contactRecords: [],
  loading: false,
  error: null,
};

export function damagingName(state = initState, action) {
  const { type, payload, error } = action;

  return produce(state, (draft) => {
    switch (type) {
      // Search Damaging Party Names
      case damagingNameConstants.SEARCH_DAMAGING_REQUEST:
      case damagingNameConstants.SEARCH_BY_CLAIM_REQUEST:
      case damagingNameConstants.SEARCH_CLAIMS_REQUEST:
      case damagingNameConstants.SEARCH_CONTACTS_REQUEST:
      case damagingNameConstants.DELETE_DAMAGING_REQUEST:
      case damagingNameConstants.UPDATE_CLAIMS_REQUEST:
      case damagingNameConstants.UPDATE_CONTACTS_REQUEST:
        draft.loading = true;
        draft.error = null;
        break;

      case damagingNameConstants.SEARCH_DAMAGING_SUCCESS:
        draft.loading = false;
        draft.damagingPartyRecords = payload;
        draft.claimRecords = [];
        draft.contactRecords = [];
        break;

      case damagingNameConstants.SEARCH_BY_CLAIM_SUCCESS:
        draft.loading = false;
        draft.claimRecords = payload;
        draft.damagingPartyRecords = [];
        draft.contactRecords = [];
        break;

      case damagingNameConstants.SEARCH_CLAIMS_SUCCESS:
        draft.loading = false;
        draft.claimRecords = payload;
        draft.contactRecords = [];
        break;

      case damagingNameConstants.SEARCH_CONTACTS_SUCCESS:
        draft.loading = false;
        draft.contactRecords = payload;
        draft.claimRecords = [];
        break;

      case damagingNameConstants.DELETE_DAMAGING_SUCCESS:
      case damagingNameConstants.UPDATE_CLAIMS_SUCCESS:
      case damagingNameConstants.UPDATE_CONTACTS_SUCCESS:
        draft.loading = false;
        break;

      case damagingNameConstants.SEARCH_DAMAGING_FAILURE:
      case damagingNameConstants.SEARCH_BY_CLAIM_FAILURE:
      case damagingNameConstants.SEARCH_CLAIMS_FAILURE:
      case damagingNameConstants.SEARCH_CONTACTS_FAILURE:
      case damagingNameConstants.DELETE_DAMAGING_FAILURE:
      case damagingNameConstants.UPDATE_CLAIMS_FAILURE:
      case damagingNameConstants.UPDATE_CONTACTS_FAILURE:
        draft.loading = false;
        draft.error = error;
        break;

      case damagingNameConstants.DAMAGING_NAME_CLEAR:
        return { ...initState };

      case REHYDRATE:
        return payload && payload.admin && payload.admin.damagingName ? { ...payload.admin.damagingName } : initState;

      default:
        return state;
    }
  });
}
